import React, { useEffect } from 'react';
import $ from 'jquery';

const Preloader: React.FC<{ onLoaded: () => void }> = ({ onLoaded }) => {
    useEffect(() => {
        $(window).on('load', function () {
            const preloader = $('#preloader');
            if (preloader.length) {
                preloader.delay(100).fadeOut('slow', function () {
                    onLoaded(); // Notify the parent component that loading is complete
                });
            }
        });
    }, [onLoaded]);

    return <div id="preloader"></div>;
};

export default Preloader;